import { addDays, differenceInCalendarDays, isToday } from "date-fns";
import { TFunction } from "i18next";
import { formatDateDDMMYYYY, formatDateHourly } from "@helpers";
import { TokenValidity } from "./constants";

export const validityToExpiresAt = (
  validity: TokenValidity
): string | undefined => {
  if (validity === "never") return undefined;
  return addDays(new Date(), Number(validity)).toISOString();
};

export const isExpired = (expiresAt?: string): boolean => {
  if (!expiresAt) return false;
  return new Date(expiresAt).getTime() <= Date.now();
};

export const isExpiringSoon = (expiresAt?: string): boolean => {
  if (!expiresAt || isExpired(expiresAt)) return false;
  const days = differenceInCalendarDays(new Date(expiresAt), new Date());
  return days >= 0 && days <= 30;
};

export const formatLastUsed = (t: TFunction, lastUsedAt?: string): string => {
  if (!lastUsedAt) return t("settings.apiAccess.table.neverUsed");
  if (isToday(new Date(lastUsedAt))) {
    return t("settings.apiAccess.table.lastUsedToday", {
      time: formatDateHourly(lastUsedAt),
    });
  }
  return formatDateDDMMYYYY(lastUsedAt);
};
